//Reset data
export const RESET = "NOTIFICATION_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "NOTIFICATION_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "NOTIFICATION_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "NOTIFICATION_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "NOTIFICATION_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "NOTIFICATION_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "NOTIFICATION_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "NOTIFICATION_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "NOTIFICATION_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "NOTIFICATION_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "NOTIFICATION_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "NOTIFICATION_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "NOTIFICATION_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "NOTIFICATION_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "NOTIFICATION_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "NOTIFICATION_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "NOTIFICATION_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "NOTIFICATION_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "NOTIFICATION_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "NOTIFICATION_SHOW_SET_MODAL_TYPE"